<div class="flex h-full">
    <button class="" (click)="onClick()"><mat-icon [svgIcon]="icon"></mat-icon></button>
</div>
